module.exports = __webpack_public_path__ + "images/sprite-ad5cdb.svg";